import { render } from "./CamaraFacial.vue?vue&type=template&id=7a2da916&scoped=true"
import script from "./CamaraFacial.vue?vue&type=script&lang=js"
export * from "./CamaraFacial.vue?vue&type=script&lang=js"

import "./CamaraFacial.vue?vue&type=style&index=0&id=7a2da916&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2da916"]])

export default __exports__